import { normalizeSwedishMoney } from "@roadadmin/domain/money";

export type { CanonicalMoney } from "@roadadmin/domain/money";
export {
  calculateVat,
  compareMoney,
  deriveInvoiceTotal,
  isPositiveMoney,
  isZeroMoney,
  normalizeSwedishMoney,
  subtractMoney,
  sumMoney,
  summarizePostingLines,
  tryNormalizeSwedishMoney,
} from "@roadadmin/domain/money";

export function formatSwedishMoney(value: string): string {
  const normalized = normalizeSwedishMoney(value);
  const negative = normalized.startsWith("-");
  const [integer, fraction] = normalized.replace(/^[+-]/, "").split(".");
  const grouped = (integer ?? "0").replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");
  return `${negative ? "−" : ""}${grouped},${fraction ?? "00"}`;
}

export function formatSwedishSek(value: string): string {
  return `${formatSwedishMoney(value)} kr`;
}
